import React, { Fragment, useState, useEffect, useRef } from "react";
import { Card, CardBody, Table, Row, Col } from "reactstrap";
import _ from "lodash";
import DefaultQuestionHit from "./Hit";
import DefaultQuestionForm from "./Form";
import Notifications from "../commons/Notifications";

const DefaultQuestionsIndex = ({ defaultQuestions }) => {
  const [questions, setQuestions] = useState([]);
  const notifications = useRef(null);

  useEffect(() => {
    setQuestions(defaultQuestions);
  }, []);

  const showNotification = (title, message, type) => {
    notifications.current.addNotifications(title, message, type);
  };

  const addQuestion = question => {
    setQuestions([...questions, question]);
  };

  const removeQuestion = questionId => {
    setQuestions(questions.filter(q => q.id !== questionId));
  };

  return (
    <Fragment>
      <Notifications ref={notifications} />
      <Card className="mb-4 material-shadow">
        <CardBody className="bg-light">
          <Row className="d-flex align-items-center">
            <Col md="8">
              <h3 className="h4 mb-0">Preguntas por Defecto</h3>
              <p className="small text-muted mb-sm-0">
                Listado de preguntas que se aplican automáticamente a las publicaciones.
              </p>
            </Col>
            <Col md="4" className="text-right">
              <DefaultQuestionForm bgColor="success" buttonText="Nueva Pregunta" showNotification={showNotification} addQuestion={addQuestion} />
            </Col>
          </Row>
        </CardBody>
      </Card>
      <Card className="material-shadow">
        <CardBody>
          <Table>
            <thead>
            <tr>
              <th>#</th>
              <th>Pregunta</th>
              <th>Tipo</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
            </thead>
            <tbody>
            {_.map(questions, (question, index) => (
              <DefaultQuestionHit key={question.id} index={index + 1} question={question} showNotification={showNotification} removeQuestion={removeQuestion} />
            ))}
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default DefaultQuestionsIndex;
